//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// todo :key="row"
import TableTr from './table-tr';
import TableCell from './cell';
import Expand from './expand.js';
import Mixin from './mixin';

var __script__ = {
  name: 'TableBody',
  mixins: [Mixin],
  components: { TableCell: TableCell, Expand: Expand, TableTr: TableTr },
  props: {
    prefixCls: String,
    styleObject: Object,
    columns: Array,
    data: Array, // rebuildData
    objData: Object,
    columnsWidth: Object,
    fixed: {
      type: [Boolean, String],
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    expandRender: function expandRender() {
      var render = function render() {
        return '';
      };
      for (var i = 0; i < this.columns.length; i++) {
        var column = this.columns[i];
        if (column.type && column.type === 'expand') {
          if (column.render) render = column.render;
        }
      }
      return render;
    }
  },
  methods: {
    rowChecked: function rowChecked(_index) {
      return this.objData[_index] && this.objData[_index]._isChecked;
    },
    rowDisabled: function rowDisabled(_index) {
      return this.objData[_index] && this.objData[_index]._isDisabled;
    },
    rowExpanded: function rowExpanded(_index) {
      return this.objData[_index] && this.objData[_index]._isExpanded;
    },
    handleMouseIn: function handleMouseIn(_index) {
      this.$parent.handleMouseIn(_index);
    },
    handleMouseOut: function handleMouseOut(_index) {
      this.$parent.handleMouseOut(_index);
    },
    clickCurrentRow: function clickCurrentRow(_index) {
      this.$parent.clickCurrentRow(_index);
    },
    dblclickCurrentRow: function dblclickCurrentRow(_index) {
      this.$parent.dblclickCurrentRow(_index);
    }
  }
};

var render = function render() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
  return _c('table', {
    style: _vm.styleObject,
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', _vm._l(_vm.columns, function (column, index) {
    return _c('col', {
      key: index,
      attrs: {
        "width": _vm.setCellWidth(column)
      }
    });
  }), 0), _vm._v(" "), _c('tbody', {
    class: [_vm.prefixCls + '-tbody']
  }, [_vm._l(_vm.data, function (row, index) {
    var _obj;

    return [_c('table-tr', {
      key: _vm.rowKey ? row._rowKey : index,
      attrs: {
        "draggable": _vm.draggable,
        "row": row,
        "prefix-cls": _vm.prefixCls
      },
      nativeOn: {
        "mouseenter": function mouseenter($event) {
          $event.stopPropagation();
          return _vm.handleMouseIn(row._index);
        },
        "mouseleave": function mouseleave($event) {
          $event.stopPropagation();
          return _vm.handleMouseOut(row._index);
        },
        "click": function click($event) {
          return _vm.clickCurrentRow(row._index);
        },
        "dblclick": function dblclick($event) {
          $event.stopPropagation();
          return _vm.dblclickCurrentRow(row._index);
        }
      }
    }, _vm._l(_vm.columns, function (column, colIndex) {
      return _c('td', {
        key: colIndex,
        class: _vm.alignCls(column, row)
      }, [_c('table-cell', {
        key: column._columnKey,
        attrs: {
          "fixed": _vm.fixed,
          "prefix-cls": _vm.prefixCls,
          "row": row,
          "column": column,
          "natural-index": index,
          "index": row._index,
          "checked": _vm.rowChecked(row._index),
          "disabled": _vm.rowDisabled(row._index),
          "expanded": _vm.rowExpanded(row._index)
        }
      })], 1);
    }), 0), _vm._v(" "), _vm.rowExpanded(row._index) ? _c('tr', {
      key: _vm.rowKey ? row._rowKey + "_expand" : index + "_expand",
      class: (_obj = {}, _obj[_vm.prefixCls + '-expanded-hidden'] = _vm.fixed, _obj)
    }, [_c('td', {
      class: _vm.prefixCls + '-expanded-cell',
      attrs: {
        "colspan": _vm.columns.length
      }
    }, [_c('Expand', {
      key: _vm.rowKey ? row._rowKey : index,
      attrs: {
        "row": row,
        "render": _vm.expandRender,
        "index": row._index
      }
    })], 1)]) : _vm._e()];
  })], 2)]);
};
var staticRenderFns = [];
var __template__ = { render: render, staticRenderFns: staticRenderFns };

export default Object.assign({}, __script__, __template__);